import SpellManagerItem from './SpellManagerItem';

export default SpellManagerItem;
export { SpellManagerItem };
